import { Region } from 'evee-ui-common/enums';
import useRegion from 'store/modules/app/hooks/useRegion';

import MetaTags from '../MetaTags';

const CommonMetaTags = () => {
  const { region } = useRegion();
  const isAustralia = region.id === Region.australia.id;

  const getTitle = () =>
    isAustralia
      ? 'evee | Tesla & Electric Car Rental in Australia'
      : 'evee | Tesla & Electric Car Rental in New Zealand';

  const getDescription = () =>
    isAustralia
      ? 'Rent Tesla, BYD, and other electric vehicles across Australia from $40/day. Comprehensive insurance included. Book your EV rental with evee today.'
      : 'Rent Tesla, BYD, and other electric vehicles across New Zealand from $40/day. Comprehensive insurance included. Book your EV rental with evee today.';

  return (
    <MetaTags
      title={getTitle()}
      keywords="electric car hire, electric car rental, electric vehicles, hire an electric car, rent out
      your car, car sharing, electric car sharing, rent a Tesla, Tesla, electric car, Hyundai
      Kona electric, Nissan Leaf, Hyundai Ioniq, jaguar i-Pace, Porsche Taycan, Tesla Model S,
      Tesla Model X, Tesla Model 3, Tesla Model Y, Tesla Australia, Mercedes EQC, Renault Zoe,
      BMW i3, cybertruck, test drive Tesla, test drive Tesla Model 3, test drive Tesla Model S,
      test drive Tesla Model X, hire a Tesla"
      description={getDescription()}
      ogUrl={`https://${region.domain}/`}
      ogImage="https://eveeh-live.s3.ap-southeast-2.amazonaws.com/assets/preview.jpg"
    />
  );
};

export default CommonMetaTags;
